/**
 * G1 / G5 — embedded SignInScreen / inline login upsells must not paint under
 * signed-in global shell chrome (avatar via isGloballySignedInChrome).
 */

import { isGloballySignedInChrome } from '../../hub/customerHubPaths.js';

export function canMountEmbeddedSignInForm(input: {
  session?: { readonly customerId: number } | null;
}): boolean {
  return !isGloballySignedInChrome(input);
}
